module.exports = __webpack_public_path__ + "img/ancillary-resilience-2.f96d7905.png";